import { api } from './client';

export interface WhatsappStatusDto {
  siteId: string;
  status: 'DISCONNECTED' | 'QR_PENDING' | 'CONNECTING' | 'CONNECTED' | 'FAILED';
  phoneNumber: string | null;
  displayName: string | null;
  connectedAt: string | null;
  qrDataUrl: string | null;
  sendHour: number;
  sendMinute: number;
  siteName?: string | null;
  siteCode?: string | null;
}

export const whatsappApi = {
  getStatus: (): Promise<WhatsappStatusDto> =>
    api.get('/whatsapp/status'),

  getQR: (): Promise<{ qrDataUrl: string | null; status: string }> =>
    api.get('/whatsapp/qr'),

  connect: (): Promise<WhatsappStatusDto> =>
    api.post('/whatsapp/connect'),

  disconnect: (): Promise<WhatsappStatusDto> =>
    api.delete('/whatsapp/disconnect'),

  updateSettings: (sendHour: number, sendMinute: number): Promise<WhatsappStatusDto> =>
    api.patch('/whatsapp/settings', { sendHour, sendMinute }),

  getAllStatus: (): Promise<WhatsappStatusDto[]> =>
    api.get('/whatsapp/all-status'),

  connectSite: (siteId: string): Promise<WhatsappStatusDto> =>
    api.post(`/whatsapp/connect/${siteId}`),

  disconnectSite: (siteId: string): Promise<WhatsappStatusDto> =>
    api.delete(`/whatsapp/disconnect/${siteId}`),

  getQRForSite: (siteId: string): Promise<{ qrDataUrl: string | null; status: string }> =>
    api.get(`/whatsapp/qr/${siteId}`),

  updateSettingsForSite: (siteId: string, sendHour: number, sendMinute: number): Promise<WhatsappStatusDto> =>
    api.patch(`/whatsapp/settings-site/${siteId}`, { sendHour, sendMinute }),
};
